import { useQueryClient } from '@tanstack/react-query';
import useMutationApi from 'src/api/useMutationApi';
import { Contact } from './useContacts';

export interface CreateContactData {
  companyId: string;
  name: string;
  email?: string;
  phone?: string;
  title?: string;
  isPrimary: boolean;
  metadata?: object | null;
}

export interface CreateContactResponse {
  data: Contact;
}

export function useCreateContact() {
  const queryClient = useQueryClient();

  return useMutationApi<CreateContactData, CreateContactResponse>({
    endpoint: 'contacts',
    method: 'POST',
    successMessage: 'Contact created successfully',
    errorMessage: 'Failed to create contact',
    options: {
      // NOTE: params _data/_variables currently unused (kept via '_' prefix) — revisit and delete if not needed
      onSuccess: (_data, _variables) => {
        // Invalidate contacts queries to refresh the data
        queryClient.invalidateQueries({
          queryKey: ['contacts'],
        });
      },
    },
  });
}

export default useCreateContact;
